export default __webpack_public_path__ + "static/media/002-nochildren.74bad1f2.svg";